<template>
    <div class="p-area">
        <div class="menu">
            <ul>
                <li><router-link to="/app/minha-conta">Minha conta</router-link></li>
                <li v-if="$root.company && $root.company.type == 2"><router-link to="/app/maquinas">Máquinas</router-link></li>
                <li v-if="$root.company && $root.company.type == 2"><router-link to="/app/servicos">Serviços</router-link></li>
                <li v-if="$root.company && $root.company.type == 2"><router-link to="/app/pedidos">Pedidos</router-link></li>
                <li v-if="$root.company && $root.company.type == 2"><router-link to="/app/slides">Slides</router-link></li>
                <li v-if="$root.company && $root.company.type == 2"><router-link to="/app/sessoes">Descubra</router-link></li>
                <li v-if="$root.company && $root.company.type == 2"><router-link to="/app/industrias">Indústrias</router-link></li>
                <li><router-link to="/app/meus-pedidos">Meus Pedidos</router-link></li>
            </ul>

        </div>
        <div>
            <router-view/>

        </div>

        
    </div>
</template>
<script>
export default {
    name: "App"
}
</script>
<style lang="scss">
    .p-area{
        display: grid;
        grid-template-columns: 1fr 6fr;
        .menu{
            // background: #233466;
            // color: #fff;
            // > *{
            //     color: #fff;
            // }
            border-right: 1px solid #ced2de;
            ul{
                padding: 0;
                li{
                    list-style: none;
                    a{
                        display: block;
                        padding: 10px;
                        box-sizing: border-box;
                        // color: #f0f0f0;
                        text-align: left;
                        transition: .3s all;
                        text-decoration: none;
                        color: #5a5e9a;
                        
                        &:hover{
                            color: #223466;
                        }
                    }
                    &:first-child {
                        a.router-link-exact-active{
                            box-shadow: inset 4px 0 0 0 #32499b;
                            background: #f5f5fa;
                        }
                    }
                    &:not(:first-child){
                        a.router-link-active{
                            box-shadow: inset 4px 0 0 0 #32499b;
                            background: #f5f5fa;
                        }
                    }
                }

            }
        }
    }
</style>